import api from "@/lib/api";
import { waLink } from "@/lib/utils-format";
import { trackWhatsAppClick } from "@/lib/analytics";

/**
 * WhatsApp CTA — direct open. Tracks click as anonymous lead in background
 * and fires GA4/Meta Pixel `whatsapp_click` / Contact events.
 */
export default function WhatsAppCTA({
    waNumber = "919971925446",
    message = "Hi, I want the best price for Signia Styletto IX.",
    productSlug = null,
    productName = null,
    sourcePage = null,
    children,
    className = "",
    "data-testid": testid,
}) {
    const onClick = () => {
        const page = sourcePage || (typeof window !== "undefined" ? window.location.pathname : null);
        api.post("/leads", {
            type: "whatsapp",
            name: "WhatsApp click",
            mobile: "anonymous",
            message,
            product_slug: productSlug,
            product_name: productName,
            source_page: page,
            whatsapp_consent: true,
        }).catch(() => { /* never block */ });
        trackWhatsAppClick({ productSlug, productName, sourcePage: page });
        window.open(waLink(waNumber, message), "_blank", "noopener,noreferrer");
    };

    return (
        <button
            type="button"
            onClick={onClick}
            className={className}
            data-testid={testid || "whatsapp-cta"}
        >
            {children}
        </button>
    );
}
